import React, { useContext, useState, useRef, useEffect } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
  formatPrice,
  pagination,
  showingData,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Moment from "react-moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import { MdDelete } from 'react-icons/md';
// import StockReport from "./StockReport";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const AccountsSupplierLedgerReport = () => {
  const { t } = useTranslation();
  let { loading, setLoading, generalSettings } = useContext(SettingsContext);
  const { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo, supplierForSearch, getSupplier } =
    useContext(UserContext);

  //toast obj
  let common_toast = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  useEffect(() => {
    getSupplier();
  }, []);

  //reportFields state
  const [reportFields, setReportFields] = useState({
    from_date: "",
    to_date: "",
    account: "",
    branch: "",
  });

  //report states
  const [reportData, setReportData] = useState(null);
  const [ledgerSummary, setLedgerSummary] = useState(null);
  const [ledgerSummaryView, setLedgerSummaryView] = useState(null);
  const [ledgerView, setLedgerView] = useState(null);
  const [option, setOption] = useState("view");
  const [reportOption,setReportOption] = useState("detail");
  const [reportType,setReportType] = useState(0);
  const [searchLedgerView, setSearchLedgerView] = useState({
    searched: false,
    list: [],
  });
  const isThrottled = useRef(false);
  const [generatedReport, setGeneratedReport] = useState(false);

  const componentRef = useRef();

  //search account here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchLedgerView({ ...searchLedgerView, searched: false });
    } else {
      let searchedList =
        ledgerView?.data &&
        ledgerView.data.filter((item) => {
          let lowerCaseItemIdentity =
            item.DocumentIdentity && item.DocumentIdentity.toLowerCase();
          let lowerCaseItemAccount = item.AccountName.toLowerCase();
          let lowerCaseItemCheque =
            item.ChequeNo && item.ChequeNo.toLowerCase();
          let lowerCaseSupplier =
            item.SupplierName && item.SupplierName.toLowerCase();
          return (
            (lowerCaseItemIdentity &&
              lowerCaseItemIdentity.includes(searchInput)) ||
            (lowerCaseItemAccount &&
              lowerCaseItemAccount.includes(searchInput)) ||
            (lowerCaseItemCheque && lowerCaseItemCheque.includes(searchInput)) || 
            (lowerCaseSupplier && lowerCaseSupplier.includes(searchInput))
          );
        });
      setSearchLedgerView({
        list: searchedList,
        searched: true,
      });
    }
  };

  const handleReportOption  = (e) =>{
    setReportOption(e.target.value)
  }

  const handleReportCheck  = () =>{
    setReportType(reportType === 0 ? 1 : 0)
  }

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const handleFromDate = (from_date) => {
    setReportFields({
      ...reportFields,
      from_date,
    });
  };

  const handleToDate = (to_date) => {
    setReportFields({
      ...reportFields,
      to_date,
    });
  };

  const handleSupplier = (supplier) => {
    setReportFields({
      ...reportFields,
      supplier,
    });
  };

  const handleBranch = (branch) => {
    setReportFields({
      ...reportFields,
      branch,
    });
  };

  const paginatedLedger = (page) => {
    if (isThrottled.current) {
      return;
    }
    isThrottled.current = true;
    setTimeout(() => {
      isThrottled.current = false;
    }, 2500);
    setLoading(true);

    const url = BASE_URL + "/settings/get-supplier-ledger-report?page=" + page;
    let { from_date, to_date, supplier, branch } = reportFields;
    const supp = supplier?.length ? JSON.stringify(supplier.map((item) => item.id)) : "";
    const branh=  branch ? JSON.stringify([branch?.id]) : "";

    let formData = new FormData();
    formData.append("from_date", moment(from_date).format("YYYY-MM-DD"));
    formData.append("to_date", moment(to_date).format("YYYY-MM-DD"));
    formData.append("supplier_id", supp);
    formData.append("branch_id", branh);
    formData.append("all_branch_check", reportType);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setLedgerView(res.data[1]);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  };

  const supplierLedgerDetailReport = () => {
    let { from_date, to_date, supplier, branch } = reportFields;
    if (option === "view") {
      paginatedLedger(1);
    } else {
      setLoading(true);
      const endPoint = "/settings/get-supplier-ledger-report";
      const url = BASE_URL + endPoint;
      let formData = new FormData();
      const supp = supplier?.length ? JSON.stringify(supplier.map((item) => item.id)) : "";
      const branh= branch ? JSON.stringify([branch?.id]) : "";
      
      formData.append("from_date", moment(from_date).format("YYYY-MM-DD"));
      formData.append("to_date", moment(to_date).format("YYYY-MM-DD"));
      formData.append("supplier_id", supp);
      formData.append("branch_id", branh);
      formData.append("all_branch_check", reportType);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setReportData(res.data[0]);
          setGeneratedReport(true);
          componentRef.current.handleDownload();
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, common_toast);
        });
    }
  };
  //summary report
  const paginatedSummaryLedger = (page) => {
    if (isThrottled.current) {
      return;
    }
    isThrottled.current = true;
    setTimeout(() => {
      isThrottled.current = false;
    }, 2500);
    setLoading(true);
    const url = BASE_URL + "/settings/get-suppliersummary-ledger-report?page=" + page;
    let { from_date, to_date, supplier, branch } = reportFields;
    const supp = supplier?.length ? JSON.stringify(supplier.map((item) => item.id)) : "";
    const branh=  branch ? JSON.stringify([branch?.id]) : "";

    let formData = new FormData();
    formData.append("from_date", moment(from_date).format("YYYY-MM-DD"));
    formData.append("to_date", moment(to_date).format("YYYY-MM-DD"));
    formData.append("supplier_id", supp);
    formData.append("branch_id", branh);
    formData.append("all_branch_check", reportType);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setLedgerView(res.data[1]);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  };
  
  const ledgerSummaryReport = ()=>{
    let { from_date, to_date, supplier, branch } = reportFields;
    // if (option === "view") {
    //   paginatedSummaryLedger(1);
    // } else {
      setLoading(true);
      const endPoint = "/settings/get-suppliersummary-ledger-report";
      const url = BASE_URL + endPoint;
      let formData = new FormData();
      const supp = supplier?.length ? JSON.stringify(supplier.map((item) => item.id)) : "";
      const branh= branch ? JSON.stringify([branch?.id]) : "";
      
      formData.append("from_date", moment(from_date).format("YYYY-MM-DD"));
      formData.append("to_date", moment(to_date).format("YYYY-MM-DD"));
      formData.append("supplier_id", supp);
      formData.append("branch_id", branh);
      formData.append("all_branch_check", reportType);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGeneratedReport(true);
          setLedgerSummary(res.data);
          componentRef.current.handleDownload();
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, common_toast);
        });
    // }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setReportData(null);
    setLedgerSummary(null);
    setLedgerSummaryView(null);
    setLedgerView(null);
    setSearchLedgerView({
      searched: false,
      list: [],
    });
    let { from_date, to_date, branch } = reportFields;
    if (
      (authUserInfo.details.user_type === "staff" ||
      authUserInfo.details.user_type === "manager") &&
      !branch?.id
    ) {
      toast.error(`${_t(t("Please select branch"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    if (from_date && to_date && (reportType === 1 ? branch : true)) {
      if(reportOption === "summary"){
        ledgerSummaryReport();
      }else{
        supplierLedgerDetailReport();
      }
    } else {
      toast.error(
        `${_t(t("Please select from date, to date & branch"))}`, common_toast
      );
    }
  };

  let balance1 = 0;
  let suppBalance = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("Suppier Ledger Report"))}</title>
      </Helmet>

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Supplier Ledger Report"
        sheet="sheet 1"
        buttonText="Report"
        ref={componentRef}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan={reportType === 0 ? "11" : "12"} style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {getSystemSettings(
                                            generalSettings,
                                            "siteName"
                                          )}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Supplier Ledger Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {reportFields.from_date}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">
                                            {reportFields.to_date}
                                          </Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                   {
                                    reportType === 1 ? (
                                      <th scope="col">{_t(t("Branch"))}</th>
                                    ) : 0
                                   }
                                  <th scope="col">{_t(t("Supplier"))}</th>
                                  <th scope="col">{_t(t("Document Id"))}</th>
                                  <th scope="col">{_t(t("Voucher Date"))}</th>
                                  <th scope="col">{_t(t("Narration"))}</th>
                                  <th scope="col">{_t(t("Cheque No"))}</th>
                                  <th scope="col">{_t(t("Cheque Date"))}</th>
                                  <th scope="col">{_t(t("Branch"))}</th>
                                  <th scope="col">{_t(t("Account Name"))}</th>
                                  <th scope="col">{_t(t("Debit"))}</th>
                                  <th scope="col">{_t(t("Credit"))}</th>
                                  <th scope="col">{_t(t("Balance"))}</th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {
                                  reportType === 0 ? (
                                    reportData && Object.keys(reportData)?.length &&
                                    Object.keys(reportData).map((supplier) => {
                                      let debit = 0;
                                      let credit = 0;
                                      let balance = 0;

                                      return (
                                        <>
                                          <tr>
                                            <td>
                                              <strong>{supplier}</strong>
                                            </td>
                                          </tr>
                                          {reportData[supplier]?.length &&
                                            reportData[supplier].map((item, i) => {
                                              balance += Number(item.Credit) - Number(item.Debit);
                                              debit += Number(item.Debit);
                                              credit += Number(item.Credit);

                                              return (
                                                <tr key={i}>
                                                  <td></td>
                                                  <td scope="row">
                                                    {item.DocumentIdentity}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.VoucherDate ? (
                                                      <Moment format="DD-MM-YYYY">
                                                        {item.VoucherDate}
                                                      </Moment>
                                                    ) : (
                                                      "-"
                                                    )}
                                                  </td>
                                                  <td scope="row">
                                                    {item.Narration}
                                                  </td>
                                                  <td scope="row">
                                                    {item.ChequeNo}
                                                  </td>
                                                  <td scope="row">
                                                    {item.ChequeDate ? (
                                                      <Moment format="DD-MM-YYYY">
                                                        {item.ChequeDate}
                                                      </Moment>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </td>

                                                  <td scope="row">
                                                    {item.branch_name}
                                                  </td>

                                                  <td scope="row">
                                                    {item.AccountName}
                                                  </td>
                                                  <td scope="row">
                                                    {formatPrice(item.Debit)}
                                                  </td>
                                                  <td scope="row">
                                                    {formatPrice(item.Credit)}
                                                  </td>
                                                  <td scope="row">
                                                    {balance < 0
                                                      ? `(${formatPrice(balance * -1)})`
                                                      : formatPrice(balance)}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <th
                                              colSpan={2}
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              Total
                                            </th>
                                            <td scope="row">
                                              <b>{formatPrice(debit)}</b>
                                            </td>
                                            <td scope="row">
                                              <b>{formatPrice(credit)}</b>
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    })
                                  ) : (
                                    reportData && Object.keys(reportData)?.length &&
                                      Object.keys(reportData).map(
                                        (group_name, index) => {
                                          return (
                                            <>
                                              <tr key={index}>
                                                <td scope="row">
                                                  <strong>{group_name}</strong>
                                                </td>
                                              </tr>
                                              {Object.keys(
                                                reportData[group_name]
                                              ).map((supplier) => {
                                                let debit = 0;
                                                let credit = 0;
                                                let balance = 0;
    
                                                return (
                                                  <>
                                                    <tr>
                                                      <td></td>
                                                      <td scope="row">
                                                        <strong>{supplier}</strong>
                                                      </td>
                                                    </tr>
                                                    {reportData[group_name][supplier]?.length &&
                                                      reportData[group_name][supplier].map((item, i) => {
                                                        balance += Number(item.Credit) - Number(item.Debit);
                                                        debit += Number(item.Debit);
                                                        credit += Number(item.Credit);
    
                                                        return (
                                                          <tr key={i}>
                                                            <td></td>
                                                            <td></td>
                                                            <td scope="row">
                                                              {item.DocumentIdentity}
                                                            </td>
                                                            <td
                                                              scope="row"
                                                              className="xsm-text text-capitalize align-middle text-center"
                                                            >
                                                              {item.VoucherDate ? (
                                                                <Moment format="DD-MM-YYYY">
                                                                  {item.VoucherDate}
                                                                </Moment>
                                                              ) : (
                                                                "-"
                                                              )}
                                                            </td>
                                                            <td scope="row">
                                                              {item.Narration}
                                                            </td>
                                                            <td scope="row">
                                                              {item.ChequeNo}
                                                            </td>
                                                            <td scope="row">
                                                              {item.ChequeDate ? (
                                                                <Moment format="DD-MM-YYYY">
                                                                  {item.ChequeDate}
                                                                </Moment>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </td>
    
                                                            <td scope="row">
                                                              {item.branch_name}
                                                            </td>
    
                                                            <td scope="row">
                                                              {item.AccountName}
                                                            </td>
                                                            <td scope="row">
                                                              {formatPrice(item.Credit)}
                                                            </td>
                                                            <td scope="row">
                                                              {formatPrice(item.Debit)}
                                                            </td>
                                                            <td scope="row">
                                                              {balance < 0
                                                                ? `(${formatPrice(balance * -1)})`
                                                                : formatPrice(balance)}
                                                            </td>
                                                          </tr>
                                                        );
                                                      })}
                                                    <tr>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                      <th
                                                        colSpan={2}
                                                        scope="row"
                                                        className="xsm-text text-capitalize align-middle text-center"
                                                      >
                                                        Total
                                                      </th>
                                                      <td scope="row">
                                                        <b>{formatPrice(debit)}</b>
                                                      </td>
                                                      <td scope="row">
                                                        <b>{formatPrice(credit)}</b>
                                                      </td>
                                                    </tr>
                                                  </>
                                                );
                                              })}
                                            </>
                                          );
                                        }
                                      )
                                  )
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {ledgerSummary !== null &&
                    ledgerSummary !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="3" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {getSystemSettings(
                                            generalSettings,
                                            "siteName"
                                          )}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Supplier Summary Ledger Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {reportFields.from_date}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">
                                            {reportFields.to_date}
                                          </Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th scope="col">{_t(t("Branch"))}</th>
                                  <th scope="col">{_t(t("Party Name"))}</th>
                                  <th scope="col">{_t(t("Balance"))}</th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {
                                  reportType === 0 ? (
                                    ledgerSummary?.length && Array.isArray(ledgerSummary) &&
                                    <>
                                      {ledgerSummary.map((item, i) => {
                                        suppBalance += Number(item.supplier_balance)
                                        return (
                                          <tr key={i}>
                                            <td></td>
                                            <td scope="row">
                                              {item.supplier_name}
                                            </td>
                                            <td scope="row">
                                              {item.supplier_balance < 0
                                                ? `(${formatPrice(item.supplier_balance * -1)})`
                                                : formatPrice(item.supplier_balance)}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      <tr>
                                        <th
                                          colSpan={2}
                                          scope="row"
                                          className="xsm-text text-capitalize align-middle text-center"
                                        >
                                          Total
                                        </th>
                                        <td scope="row">
                                          <b>{suppBalance < 0 ? `(${formatPrice(suppBalance * -1)})` : formatPrice(suppBalance)}</b>
                                        </td>
                                      </tr> 
                                    </>  
                                  ) : (
                                    ledgerSummary &&
                                      Object.keys(ledgerSummary).map(
                                        (group_name, index) => {
                                          let totalBalance = 0
                                          return (
                                            <>
                                              <tr key={index}>
                                                <td scope="row">
                                                  <strong>{group_name}</strong>
                                                </td>
                                              </tr>
                                              {ledgerSummary[group_name]?.length &&
                                                ledgerSummary[group_name].map((item, i) => {
                                                  totalBalance += Number(item.supplier_balance);
                                                  return (
                                                    <tr key={i}>
                                                      <td></td>
                                                      <td scope="row">
                                                        {item.supplier_name}
                                                      </td>
                                                      <td scope="row">
                                                        {item.supplier_balance < 0
                                                          ? `(${formatPrice(item.supplier_balance * -1)})`
                                                          : formatPrice(item.supplier_balance)}
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                            <tr>
                                              <th
                                                colSpan={2}
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                Total
                                              </th>
                                              <td scope="row">
                                                <b>{formatPrice(totalBalance)}</b>
                                              </td>
                                            </tr>
                                            </>
                                          );
                                        }
                                      )
                                  )
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <AccountsSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading}/>
                    {/* spin loading ends */}

                    <div key="fragment-3">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Supplier Ledger Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7 d-flex justify-content-end align-items-center">
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <div className="d-inline mr-2 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="view_report"
                                name="view_report"
                                value="view"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "view"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="view_report"
                                style={{
                                  fontSize: "16px",
                                  borderRadius: "5px",
                                }}
                              >
                                <i class="fa fa-eye" aria-hidden="true"></i>{" "}
                                {_t(t("View"))}
                              </label>
                            </div>
                          </div>
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="excel_report"
                              name="excel_report"
                              value="excel"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={option === "excel"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="excel_report"
                              style={{ fontSize: "16px", borderRadius: "5px" }}
                            >
                              <i class="fa fa-table" aria-hidden="true"></i>{" "}
                              {_t(t("Excel"))}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <div className="card mb-2 mx-1 px-2">
                        <form
                          className="row p-1 mx-0 mb-2 table-text"
                          onSubmit={handleSubmit}
                        >
                          <div className="col-12">
                            <div>
                              <div className="row">
                                <div className="form-group col-2 text-right mt-2">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="fromDate"
                                      className="control-label"
                                    >
                                      {_t(t("From Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={reportFields.from_date}
                                      onChange={(date) => handleFromDate(date)}
                                      peekNextMonth
                                      maxDate={new Date()}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("From Date"))}
                                      shouldCloseOnSelect={false}
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-2 text-right mt-2">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="toDate"
                                      className="control-label"
                                    >
                                      {_t(t("To Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={reportFields.to_date}
                                      onChange={(date) => handleToDate(date)}
                                      peekNextMonth
                                      maxDate={new Date()}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("To Date"))}
                                      shouldCloseOnSelect={false}
                                    />
                                  </div>
                                </div>

                                <div className="form-group mt-2 col-2">
                                  <div className="mb-2 text-left d-flex align-items-center">
                                    <label
                                      style={{width: "45%"}}
                                      htmlFor="transaction"
                                      className="control-label mr-2"
                                    >
                                      {_t(t("Branch"))}
                                      {reportType === 1 && 
                                      <span className="text-danger">*</span>}
                                    </label>
                                    <div style={{width: "47%"}}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input pointer-cursor"
                                        id="all_branch_check"
                                        name="all_branch_check"
                                        value="0"
                                        checked={reportType === 1}
                                        onChange={(e) => handleReportCheck()}
                                      />
                                      <label
                                        className="form-radio-label pointer-cursor ml-2"
                                        htmlFor="all_branch_check"
                                      >
                                        {_t(t("Branch"))}
                                      </label>
                                    </div>
                                  </div>
                                  <Select
                                    options={
                                      branchForSearch ? branchForSearch : []
                                    }
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={reportFields.branch || ""}
                                    classNamePrefix="select table-text"
                                    onChange={(branch) => handleBranch(branch)}
                                    isClearable
                                    placeholder={_t(t("Select branch")) + ".."}
                                    styles={customStyle}
                                  />
                                </div>

                                <div className="form-group col-4 d-flex mt-2">
                                  <div style={{width: "63%"}} className="mr-3">
                                    <div className="mb-2 text-left">
                                      <label
                                        htmlFor="transaction"
                                        className="control-label"
                                      >
                                        {_t(t("Supplier"))}
                                      </label>
                                    </div>
                                    <Select
                                      options={
                                        supplierForSearch ? supplierForSearch : []
                                      }
                                      menuPosition="fixed"
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={reportFields.supplier || ""}
                                      isMulti
                                      classNamePrefix="select table-text"
                                      onChange={(supp) => handleSupplier(supp)}
                                      placeholder={
                                        _t(t("Select supplier")) + ".."
                                      }
                                      styles={customStyle}
                                    />
                                  </div>
                                  <div className="mr-1">
                                    <div className="mt-3 text-truncate">
                                      <input
                                        type="radio"
                                        className="form-check-input pointer-cursor"
                                        id="detail"
                                        name="type"
                                        value="detail"
                                        checked={reportOption==="detail"}
                                        onChange={(e) => handleReportOption(e)}
                                      />
                                      <label
                                        className="form-radio-label pointer-cursor ml-1"
                                        htmlFor="detail"
                                      >
                                        {_t(t("Detail"))}
                                      </label>
                                    </div>

                                    <div className="mt-2 text-truncate">
                                      <input
                                        type="radio"
                                        className="form-check-input pointer-cursor"
                                        id="summary"
                                        name="type"
                                        value="summary"
                                        checked={reportOption==="summary"}
                                        onChange={(e) => handleReportOption(e)}
                                      />
                                      <label
                                        className="form-radio-label pointer-cursor ml-1"
                                        htmlFor="summary"
                                      >
                                        {_t(t("Summary"))}
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{ textAlign: "right" }}
                                  className="form-group mt-4 col-2"
                                >
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded mt-2"
                                  >
                                    {_t(t("Print Supplier"))}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>

                        {/* view report */}
                        {ledgerView?.data ||
                        (searchLedgerView && searchLedgerView?.list?.length) ? (
                          <div className="row">
                            <div className="col-12">
                              <div className="d-flex justify-content-end mb-1">
                                <div className="form-file">
                                  <input
                                    type="text"
                                    className="form-control border-0 form-control--light-1 table-text rounded-sm py-1"
                                    placeholder={_t(t("Search")) + ".."}
                                    onChange={handleSearch}
                                  />
                                </div>
                              </div>
                              <div className="row gx-2 justify-content-center py-2 report border border-1 rounded-sm">
                                <div
                                  className="col-12 bill_modal_scroll"
                                  style={{ height: "calc(100vh - 23.7rem)" }}
                                >
                                  <table
                                    className="table table-bordered my-1"
                                    id="table-to-xls"
                                  >
                                    <thead className="align-middle sm-text">
                                      <tr
                                        style={{
                                          position: "sticky",
                                          top: "-0.1px",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("S.No"))}
                                        </th>
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Document Id"))}
                                        </th>
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Voucher Date"))}
                                        </th>

                                        {/* <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Branch"))}
                                        </th> */}

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Supplier"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Narration"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Account Name"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Debit"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Credit"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Balance"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Cheque No"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Cheque Date"))}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="align-middle sm-text">
                                      {/* loop here*/}
                                      {ledgerView?.data &&
                                      !searchLedgerView.searched ? (
                                        ledgerView.data?.length ? (
                                          ledgerView?.data.map(
                                            (item, index) => {
                                              balance1 += Number(item.Credit) - Number(item.Debit);
                                              return (
                                                <tr key={index}>
                                                  <th
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {index +
                                                      1 +
                                                      (ledgerView.current_page -
                                                        1) *
                                                        ledgerView.per_page}
                                                  </th>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center "
                                                  >
                                                    {item.DocumentIdentity}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.VoucherDate ? (
                                                      <Moment format="DD-MM-YYYY">
                                                        {item.VoucherDate}
                                                      </Moment>
                                                    ) : (
                                                      "-"
                                                    )}
                                                  </td>
                                                  {/* <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.branch_name}
                                                  </td> */}
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center "
                                                  >
                                                    {item.SupplierName}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.Narration}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.AccountName}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.Debit)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.Credit)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {balance1 < 0
                                                      ? `(${formatPrice(balance1 * -1)})`
                                                      : formatPrice(balance1)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.ChequeNo}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.ChequeDate ? (
                                                      <Moment format="DD-MM-YYYY">
                                                        {item.ChequeDate}
                                                      </Moment>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )
                                        ) : (
                                          <tr>
                                            {" "}
                                            <td
                                              className="text-capitalize align-middle text-center"
                                              colSpan="8"
                                            >
                                              No Data
                                            </td>
                                          </tr>
                                        )
                                      ) : searchLedgerView.list &&
                                        searchLedgerView.list?.length ? (
                                        searchLedgerView.list.map(
                                          (item, index) => {
                                            balance1 += Number(item.Credit) - Number(item.Debit);
                                            return (
                                              <tr key={index}>
                                                <th
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {index +
                                                    1 +
                                                    (ledgerView.current_page -
                                                      1) *
                                                      ledgerView.per_page}
                                                </th>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center "
                                                >
                                                  {item.DocumentIdentity}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {item.VoucherDate ? (
                                                    <Moment format="DD-MM-YYYY">
                                                      {item.VoucherDate}
                                                    </Moment>
                                                  ) : (
                                                    "-"
                                                  )}
                                                </td>
                                                {/* <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {item?.branch_name}
                                                </td> */}
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center "
                                                >
                                                  {item.SupplierName}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {item.Narration}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {item.AccountName}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {formatPrice(item.Credit)}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {formatPrice(item.Debit)}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {balance1 < 0
                                                    ? `(${formatPrice(balance1 * -1)})`
                                                    : formatPrice(balance1)}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {item.ChequeNo}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {item.ChequeDate ? (
                                                    <Moment format="DD-MM-YYYY">
                                                      {item.ChequeDate}
                                                    </Moment>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      ) : (
                                        <tr>
                                          {" "}
                                          <td
                                            className="text-capitalize align-middle text-center"
                                            colSpan="8"
                                          >
                                            No Data
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            {ledgerView?.data && (
                              <>
                                <div className="mt-1 t-pt-5 t-pb-5">
                                  <div className="row align-items-center t-pl-15 t-pr-15">
                                    <div className="col-md-7 t-mb-15 mb-md-0">
                                      {/* pagination function */}
                                      {pagination(ledgerView, paginatedLedger)}
                                    </div>
                                    <div className="col-md-5">
                                      <ul className="t-list d-flex justify-content-md-end align-items-center">
                                        <li className="t-list__item">
                                          <span className="d-inline-block sm-text">
                                            {showingData(ledgerView)}
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                         {/* view summary report */}
                         {ledgerSummaryView?.data ? (
                          <div className="row">
                            <div className="col-12">
                              <div className="row gx-2 justify-content-center py-2 report border border-1 rounded-sm">
                                <div
                                  className="col-12 bill_modal_scroll"
                                  style={{ height: "22rem" }}
                                >
                                  <table
                                    className="table table-bordered my-1"
                                    id="table-to-xls"
                                  >
                                    <thead className="align-middle sm-text">
                                      <tr
                                        style={{
                                          position: "sticky",
                                          top: "-0.1px",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("S.No"))}
                                        </th>
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Branch"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Party Name"))}
                                        </th>
                                       
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Balance"))}
                                        </th>

                                      </tr>
                                    </thead>
                                    <tbody className="align-middle sm-text">
                                      {/* loop here*/}
                                      {ledgerSummaryView?.data && (
                                        ledgerSummaryView.data?.length ? (
                                          ledgerSummaryView?.data.map(
                                            (item, index) => {
                                              return (
                                                <tr key={index}>
                                                  <th
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {index +
                                                      1 +
                                                      (ledgerSummaryView.current_page -
                                                        1) *
                                                        ledgerSummaryView.per_page}
                                                  </th>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center "
                                                  >
                                                    {item.branchName}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center "
                                                  >
                                                    {item.supplier_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.supplier_balance < 0
                                                      ? `(${formatPrice(item.supplier_balance * -1)})`
                                                      : formatPrice(item.supplier_balance)}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )
                                        ) : (
                                          <tr>
                                            {" "}
                                            <td
                                              className="text-capitalize align-middle text-center"
                                              colSpan="8"
                                            >
                                              No Data
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            {ledgerSummaryView?.data && (
                              <>
                                <div className="mt-1 t-pt-5 t-pb-5">
                                  <div className="row align-items-center t-pl-15 t-pr-15">
                                    <div className="col-md-7 t-mb-15 mb-md-0">
                                      {/* pagination function */}
                                      {pagination(ledgerView, paginatedLedger)}
                                    </div>
                                    <div className="col-md-5">
                                      <ul className="t-list d-flex justify-content-md-end align-items-center">
                                        <li className="t-list__item">
                                          <span className="d-inline-block sm-text">
                                            {showingData(ledgerView)}
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default AccountsSupplierLedgerReport;
